// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GsIba","right":"styles_right__1Krj4"};